<template>
    <div>   
        <div class="Admin_Dashboard__contents">
            <div class="Admin_Dashboard__user_table">
                <div class="Admin_Dashboard__user_table__title">
                    <h2>참가자 정보 조회</h2>
                    <div class="Admin_Dashboard__user_search">
                        <v-icon class="mdi mdi-magnify icon" />
                        <input v-model="searchQuery" placeholder="검색어를 입력하세요.">
                    </div>
                </div>
                <div class="Admin_Dashboard__user_table__wrap">
                    <div class="admin-button-group">
                        <v-btn @click="refreshBtn" class="refreshBtn" icon>
                            <v-icon>mdi-refresh </v-icon>
                        </v-btn>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                v-bind="attrs"
                                v-on="on"
                                @click="downloadBtn"
                                class="downloadBtn"
                                icon
                                >
                                <v-icon>mdi-download</v-icon></v-btn>
                                <!-- <v-icon>mdi mdi-microsoft-excel</v-icon></v-btn> -->
                            </template>
                            <span>접속로그 다운로드</span>
                        </v-tooltip>
                     </div>
                    <v-data-table
                    item-key="user_id"
                    :headers="headers"
                    :items="filteredUserList"
                    :items-per-page="10"
                    class="data-table"
                    :search="searchQuery"
                    :loading="loading"
                    >
                    <template v-slot:item.stay_duration="{item}">
                        {{ formatTime(item.stay_duration) }}
                    </template>
                    <!-- <template v-slot:item.breakTime="{item}">
                        {{ formatTime(item.breakTime) }}
                    </template> -->
                    </v-data-table>
                </div>
            </div>
        </div>
    </div>  
</template>

<script>
export default {
    props: {
        userList: {
            type: Array,
            required: true,
        },
        load: {
            type: Boolean,
            required: true,
        },
        reloadUserData: {
            type: Function,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        }
    },
    computed: {
        filteredUserList() {
            const query = this.searchQuery ? this.searchQuery.toLowerCase() : ''; 
            return this.userList.filter(e =>
                e.username.toLowerCase().includes(query)
            );
        }
    },
    data () {
        return {
            searchQuery: null,
            headers: [
                {
                    text: '이름',
                    align: 'start',
                    sortable: false,
                    value: 'username',
                    class: 'custom-header',
                },
                { text: '최근 로그인', value: 'last_login' },
                { text: '최근 로그아웃', value: 'last_logout' },
                { text: '체류시간', value: 'stay_duration' },
            ],
        }
    },
    methods: {
        formatTime(seconds) {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const secs = seconds % 60;

            const formattedHours = hours > 0 ? `${hours}시` : '';
            const formattedMinutes = minutes > 0 ? `${minutes}분` : '';
            const formattedSeconds = secs > 0 ? `${secs}초` : '';
            // const formattedHours = `${hours}시`;
            // const formattedMinutes = `${minutes}분`;
            // const formattedSeconds = `${secs}초`;

            return `${formattedHours} ${formattedMinutes} ${formattedSeconds}`.trim();   
        },
        refreshBtn(){
            this.reloadUserData();
        },
        downloadBtn(){
            this.$emit('download-Btn')
        }
    }
}
</script>

<style scoped>
@media screen and (max-width:680px) {
    .v-data-table >>> .v-data-table-header-mobile__wrapper { width: 90%; }
}
</style>

